export function isEdmundsReferrer(referer) {
  try {
    const { hostname } = new URL(referer);
    return hostname.endsWith('.edmunds.com');
  } catch {
    return false;
  }
}

export function isReferredUrlFromEdmunds() {
  if (typeof document !== 'undefined') {
    return document.referrer.includes('edmunds.com');
  }
  return false;
}
